import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData, getDetailsData } from '../FlowEfficiencyActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import AvgFE from '../components/AvgFE';
import FlowEfficiencyChart from '../components/FlowEfficiencyChart';
import FEDetailsAccordion from '../../../components/DetailsAccordion/FEDetailsAccordion';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import './../FlowEfficiency.scss';

class FlowEfficiency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    props.dispatch(setPageName('Flow Efficiency Chart'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('fe');

      trackTeamDashboardView('fe');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.enabledColors != this.props.enabledColors) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    } else if (
      prevProps.effRange != this.props.effRange ||
      prevProps.selectedQueueLists != this.props.selectedQueueLists
    ) {
      this.setState({
        selectedPoint: {}
      });
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
      this.props.getDetailsData(this.props.dates);
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('fe', true);
  };

  trackHowToFEOpen() {
    trackHowToOpened('fe');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Analyze your flow efficiency</li>
            <li>Identify the tasks with the longest waiting times</li>
            <li>Monitor how your flow efficiency trends build over time</li>
          </ul>
          <a
            href={`https://getnave.com/flow-efficiency-chart`}
            target="_blank"
            onClick={this.trackHowToFEOpen}
            onAuxClick={this.trackHowToFEOpen}
            className='btn btn-secondary'
            >
              Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Flow Efficiency Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} showAvgChart enableQueueLists enableMarkBlocked disabledLists={['todo', 'done']} />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>Flow Efficiency Chart</h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options switchChartType showNavigator showAvgChart options={{ avgChartTooltip: 'Average Flow Efficiency' }} />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details">
            {this.props.data.series && !!this.props.data.series.length && this.props.avgChart && (
              <AvgFE data={this.props.data.series} dateFormat={this.props.dateFormat} widget="afe" />
            )}
            <FEDetailsAccordion id="details-accordion" data={this.state.selectedPoint} blockedTime={this.props.blockedTime} blockers={this.props.blockers} />
          </div>
          <div className="diagram_details">
            <FlowEfficiencyChart id="FlowEfficiency" data={this.props.data} onPointClick={this.handlePointClick} blockedTime={this.props.blockedTime} />
            <NoData
              show={this.props.data.series && !this.props.data.series.length}
              loading={this.props.detailsIsLoading || this.props.isLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    getDetailsData: dates => dispatch(getDetailsData(dates))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    dateFormat: state.filters.dateFormat,
    enabledColors: state.filters.enabledColors,
    blockedTime: state.filters.fe.blockedTime,
    blockers: state.filters.fe.blockers,
    dates: state.filters.dates,
    hash: state.filters.fe.hash,
    avgChart: state.filters.fe.avgChart,
    effRange: state.filters.fe.effRange,
    selectedQueueLists: state.filters.fe.selectedQueueLists,
    data: state.fe.data,
    isLoading: state.fe.isLoading,
    detailsIsLoading: state.fe.detailsIsLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowEfficiency);
